<template>
  <confirmation-modal :is-open="isModalOpen">
    Are you sure you want to delete this {{ deleteType }}?
    <template slot="primary">
      <button
          slot="primary"
          class="BUTTON-PRIMARY"
          selenium="modal-off-leads"
          @click.prevent="onDelete"
      >Delete</button>
    </template>
    <template slot="secondary">
      <button
          slot="secondary"
          class="BUTTON-TERTIARY"
          @click.prevent="$emit('secondary')"
      >Cancel</button>
    </template>
  </confirmation-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import appointments from '@/mixins/job/appointments';
import ConfirmationModal from './ConfirmationModal';

export default {
  name: 'delete-modal',
  components: {
    ConfirmationModal,
  },
  mixins: {
    appointments,
  },
  props: {
    isOpen: Boolean,
    deleteType: {
      type: String,
    },
    deleteItem: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      isModalOpen: this.isOpen,
    };
  },
  computed: {
    ...mapGetters('account/pro', ['serviceProviderCatalogOccupations']),
  },
  watch: {
    isOpen (val) {
      this.isModalOpen = val;
    },
  },
  methods: {
    ...mapActions('account/pro', [
      'deleteServiceProviderOccupationUnavailability',
      'deleteServiceProviderUnavailability',
    ]),
    ...mapActions('dashboard/job', ['deleteAppointments']),
    onDelete () {
      if (this.deleteType === 'pause') {
        this.deletePause();
      } else {
        this.onAppointmentsDelete();
      }
    },
    async deletePause () {
      try {
        if (this.deleteItem.serviceProviderOccupationId) {
          await this.deleteServiceProviderOccupationUnavailability({
            unavailabilityId: this.deleteItem.id,
          });
        } else {
          await this.deleteServiceProviderUnavailability({ unavailabilityId: this.deleteItem.id });
        }
        this.$events.$emit(
          this.$events.PRO_PAUSE_DELETE,
          {
            occupation: this.deleteItem.serviceProviderOccupationId
              ? this.serviceProviderCatalogOccupations[this.deleteItem.serviceProviderOccupationId]
                .occupation.display_name : 'All',
          });
        this.$emit('secondary');
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
        this.$emit('secondary');
        this.$events.$emit(this.$events.PRO_PAUSE_DELETE_ERROR, {
          errorMessage: err,
          occupation: this.deleteItem.serviceProviderOccupationId
            ? this.serviceProviderCatalogOccupations[this.deleteItem.serviceProviderOccupationId]
              .occupation.display_name
            : 'All',
        });
      }
    },
    async onAppointmentsDelete () {
      await this.deleteAppointments({
        order_hash: this.deleteItem.appointment.order_hash,
        service_provider_id: this.deleteItem.appointment.service_provider_id,
        appointmentId: this.deleteItem.appointment.id,
      });
      this.$emit('secondary');
      this.trackUpdates(this.$events.APPOINTMENT_DELETED);
    },
    trackUpdates (event) {
      this.$events.$emit(event, {
        jobId: this.deleteItem.jobId,
        startDate: this.deleteItem.appointment.start_dtm,
        endDate: this.deleteItem.appointment.end_dtm,
        address: this.deleteItem.appointment.address,
        type: this.deleteItem.appointment.purpose,
        message: this.deleteItem.appointment.otherPurpose,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  @import "~@/views/Dashboard/constants";

  .CONFIRMATION-BODY {
    @include responsive(min-width, 100%, $confirmation-modal-width);
    @include responsive(width, 100%, $confirmation-modal-width);
    @include responsive(max-width, 100%, $confirmation-modal-width);
    display: flex;
    flex-direction: column;
  }

  .HEADER {
    @include h6;
    padding: $unit;
    font-weight: 700;
    text-align: center;
    border-bottom: 1px solid $color-gray30;
  }

  .CONTENT {
    padding: 4*$unit 3*$unit 3*$unit;
    text-align: center;
  }

  .FOOTER {
    display: flex;
    padding: 0 3*$unit 3*$unit;
    background-color: white;
  }

  .BUTTON-TERTIARY,
  .BUTTON-PRIMARY {
    @include button-medium;
    display: flex;
    flex: 1 1 auto;
    font-weight: 600;
  }

  .BUTTON-TERTIARY {
    @include button-tertiary;
    margin-right: 1.5*$unit;
  }

  .BUTTON-PRIMARY {
    @include button-primary;
    margin-left: 1.5*$unit;
  }
</style>
